import { useSelector } from 'react-redux';
import { HealthCareData } from './HealthCare.meta';
import {
  selectCurrentClient,
  selectIsCanadian,
} from '../../../../CommonSelectors/CommonAreaSelector';
import { AT_RETIREMENT } from '../../Goals.meta';

interface Params {
  goalData: HealthCareData;
  yearsOptions: number[];
}

export const useHealthCare = ({ goalData, yearsOptions }: Params) => {
  const isCanadian = useSelector(selectIsCanadian);

  const { Dob: primaryDob, PartnerDob: spouseDob } = useSelector(selectCurrentClient);

  const primaryYob = primaryDob ? new Date(primaryDob).getFullYear() : null;
  const spouseYob = spouseDob ? new Date(spouseDob).getFullYear() : null;

  return {
    ...goalData,
    isCanadian,
    startYearOptions: [
      { label: AT_RETIREMENT, value: AT_RETIREMENT },
      ...yearsOptions.map(year => ({
        label: year.toString(),
        value: year,
        rightLabel: primaryYob
          ? `Age ${year - primaryYob}${spouseYob ? `, Age ${year - spouseYob}` : ''}`
          : undefined,
      })),
    ],
  };
};
